import './styles/style.scss';
import './scripts/main';

import { customSelectHandler } from './UI/form-controls/form-controls';
import { accordionNITG } from './UI/accordion/accordion'
import { ResizeTextArea, nitgFormEmailsChanges } from "./scripts/main";
import { NITGPostLoader } from "./scripts/posts";
import { nitgMapInit } from "./scripts/map";

window.ResizeTextArea = ResizeTextArea;
window.customSelectHandler = customSelectHandler;
window.accordionNITG = accordionNITG;
window.NITGPostLoader = NITGPostLoader;
window.nitgMapInit = nitgMapInit;
window.nitgFormEmailsChanges = nitgFormEmailsChanges;